import { useEffect, useRef } from 'react';
import { isPerformanceAPISupported } from '@/constants/performance';
import { trace, TraceEventPayload } from '@/utils/trace';

interface UsePerformanceMarkerOptions {
  name: string;
  eventName?: string;
  ready: boolean;
  additionalEndName?: string;
  additionalStartName?: string;
  payload?: TraceEventPayload;
}

export const usePerformanceMeasure = ({
  name,
  eventName,
  ready,
  additionalStartName,
  additionalEndName,
  payload,
}: UsePerformanceMarkerOptions) => {
  const markerCalled = useRef(false);
  const start = useRef(isPerformanceAPISupported ? performance.now() : 0);

  useEffect(() => {
    if (!ready || markerCalled.current) return;
    markerCalled.current = true;
    trace.measure(name, { start: start.current, eventName, additionalStartName, additionalEndName, payload });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [name, ready]);
};
